/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiSimplePersonalisationFromJSON, ApiSimplePersonalisationToJSON, } from './ApiSimplePersonalisation';
export function ApiListPersonalisationsResponseFromJSON(json) {
    return ApiListPersonalisationsResponseFromJSONTyped(json, false);
}
export function ApiListPersonalisationsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'personalisations': !exists(json, 'personalisations') ? undefined : (json['personalisations'].map(ApiSimplePersonalisationFromJSON)),
    };
}
export function ApiListPersonalisationsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'personalisations': value.personalisations === undefined ? undefined : (value.personalisations.map(ApiSimplePersonalisationToJSON)),
    };
}
